import React from 'react';
import { motion } from 'framer-motion';

export default function Home0() {
    // Opens the Calendly demo link in a new tab
    const handleClick = () => {
        window.open(
            'https://calendly.com/krishiyan-info/30min',
            '_blank'
        );
    };

    return (
        <section id="home0" className="pt-12 md:pt-16 lg:pt-10">
            <motion.div
                className="flex flex-col md:flex-row items-center justify-between px-4 md:px-8 lg:px-16"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                {/* Text Content */}
                <div className="w-full md:w-1/2 text-center md:text-left">
                    {/* Badge */}
                    <div className="inline-flex items-center bg-gray-100 px-4 py-2 rounded-full">
                        <img
                            src="/Images/tabler_cloud-computing.png"
                            alt="Cloud icon"
                            className="h-6 w-6 mr-2"
                        />
                        <span className="text-sm font-semibold text-green-600">
                            Cloud-Powered Platform
                        </span>
                    </div>

                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold mt-6">
                        Cloud-Powered Integrated Solutions for FPOs
                    </h1>

                    <p className="mt-4 text-base md:text-lg text-gray-700 leading-relaxed">
                        KrishiYan by WetAcre Sustainable Solutions is a cloud-based platform empowering
                        farmers and FPOs with advanced tools for efficient farming, real-time insights,
                        and seamless market access, fostering sustainable and profitable agriculture.
                    </p>

                    <button
                        onClick={handleClick}
                        className="mt-6 px-6 py-3 bg-green-500 text-white font-bold rounded-full text-lg hover:bg-green-600 hover:shadow-lg transition"
                    >
                        Request a Demo <span className="ml-2 text-xl">→</span>
                    </button>
                </div>

                {/* Image Content */}
                <div className="w-full md:w-1/2 mt-8 md:mt-0 flex justify-center md:justify-end px-4">
                    <img
                        src="/Images/Home-image.png"
                        alt="Farmer holding harvested grains"
                        className="w-[80%] max-w-sm md:max-w-md lg:max-w-lg h-auto rounded-xl shadow-md"
                    />
                </div>
            </motion.div>
        </section>
    );
}
